import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCustomerDriverSearch = () => {
  const customerDriverSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/driver/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { customerDriverSearch }
}

export default InteractorCustomerDriverSearch
